import { makeAutoObservable } from 'mobx';
import { UserSettings, WorkspaceSettings, ApplicationSettings, Emoji, Setting } from '../types';
import {
	DEFAULT_USER_SETTINGS,
	DEFAULT_WORKSPACE_SETTINGS,
	DEFAULT_APPLICATION_SETTINGS,
	DEFAULT_USER_EMOJI,
	DEFAULT_WORKSPACE_EMOJI,
	DEFAULT_APPLICATION_EMOJI,
} from '../constants/DefaultSettings';
import { RootStore } from './RootStore';

/**
 * SettingsStore
 */
export class SettingsStore {
	rootStore: RootStore;

	userSettings: UserSettings = Object.assign({}, DEFAULT_USER_SETTINGS);
	workspaceSettings: WorkspaceSettings = Object.assign({}, DEFAULT_WORKSPACE_SETTINGS);
	applicationSettings: ApplicationSettings = Object.assign({}, DEFAULT_APPLICATION_SETTINGS);

	userEmoji: Emoji[] = [...DEFAULT_USER_EMOJI];
	workspaceEmoji: Emoji[] = [...DEFAULT_WORKSPACE_EMOJI];
	applicationEmoji: Emoji[] = [...DEFAULT_APPLICATION_EMOJI];

	settingsUpdated: any = {
		userSettings: false,
		workspaceSettings: false,
		applicationSettings: false,
	};

	constructor(rootStore: RootStore) {
		makeAutoObservable(this, { rootStore: false });
		this.rootStore = rootStore;
		this.init();
	}

	init() {
		this.rootStore.userStore.UserIdChanged.on(() => {
			this.syncSettings();
		});
	}

	setSetting(settingName: string, setting: Setting) {
		if (Object.prototype.hasOwnProperty.call(this.userSettings, settingName)) {
			this.userSettings[settingName as keyof UserSettings].value = setting.value;
			this.settingsUpdated.userSettings = true;
		}

		if (Object.prototype.hasOwnProperty.call(this.workspaceSettings, settingName)) {
			this.workspaceSettings[settingName as keyof WorkspaceSettings].value = setting.value;
			this.settingsUpdated.workspaceSettings = true;
		}

		if (Object.prototype.hasOwnProperty.call(this.applicationSettings, settingName)) {
			this.applicationSettings[settingName as keyof ApplicationSettings].value = setting.value;
			this.settingsUpdated.applicatonSettings = true;
		}

		this.syncSettings();
	}

	getSetting(settingName: string) {
		if (Object.prototype.hasOwnProperty.call(this.applicationSettings, settingName)) {
			return this.applicationSettings[settingName as keyof ApplicationSettings];
		}

		return null;
	}

	syncSettings() {
		// if has rights to save user settings and has changed settings
		// this.settingsUpdated.userSettings = false;

		// if has right to save workspace settings and has changed settings
		// this.settingsUpdated.userSettings = false;

		// if has magical powers and can save application settings in cloud and has changed settings
		// this.settingsUpdated.userSettings = false;

		// finally get settings from cloud
		this.fetchSettings();
	}

	fetchSettings() {
		this.fetchUserSettings();
		this.fetchWorkspaceSettings();
	}

	fetchUserSettings() {}

	fetchWorkspaceSettings() {}

	/* UTILS */
	get allEmojis(): Emoji[] {
		return [...this.userEmoji, ...this.workspaceEmoji, ...this.applicationEmoji];
	}

	applyEmojiSettingsToText(text: string | null | undefined) {
		// skip parsing if we don't need to do anything
		if (!text || text.indexOf(':') < 0) {
			return text;
		}
		let enhanced = text;
		this.allEmojis
			.filter((e: Emoji) => e.utf8Emoji)
			.forEach((emoji: Emoji) => {
				if (emoji.utf8Emoji) {
					enhanced = enhanced.replaceAll(`:${emoji.name}:`, emoji.utf8Emoji);
				}
			});

		return enhanced;
	}
}
